export default "__VITE_ASSET__BnAoNG8V__"